import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// fonts.css строго до index.css: @font-face должны быть объявлены раньше,
// чем что-либо начнёт их запрашивать.
import './fonts.css';
import './index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
